import { useState } from 'react';
import { galleryWorks, styleCategories, type Work } from '@/mocks/gallery';

const allStyles = ['全部', ...styleCategories.map((s) => s.name)];

export default function Gallery() {
  const [active, setActive] = useState('全部');
  const [liked, setLiked] = useState<number[]>([]);

  const filtered: Work[] = active === '全部' ? galleryWorks : galleryWorks.filter((w) => w.style === active);

  const toggleLike = (id: number) => {
    setLiked((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  return (
    <section id="latest" className="relative w-full scroll-mt-16 bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-2">
          <span className="text-sm font-medium uppercase tracking-widest text-primary-400">Latest Gallery</span>
          <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-4xl">最新图集</h2>
          <p className="max-w-2xl text-sm text-foreground-300 md:text-base">
            每日更新的同人插画精选，按风格轻松筛选，点开即可收藏下载心仪的美图。
          </p>
        </div>

        <div className="mt-6 flex flex-wrap items-center gap-2">
          {allStyles.map((style) => (
            <button
              key={style}
              type="button"
              onClick={() => setActive(style)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                active === style
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200/60 text-foreground-300 hover:bg-background-300/50 hover:text-foreground-100'
              }`}
            >
              {style}
            </button>
          ))}
        </div>

        <div className="mt-8 columns-1 gap-5 sm:columns-2 lg:columns-3 [&>*]:mb-5">
          {filtered.map((work) => {
            const isLiked = liked.includes(work.id);
            return (
              <article
                key={work.id}
                className="group relative break-inside-avoid overflow-hidden rounded-lg bg-background-50"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={work.image}
                    alt={`${work.title} - ${work.style}同人插画壁纸`}
                    title={`${work.title} ${work.style}同人插画`}
                    className={`w-full object-cover object-top transition-transform duration-500 group-hover:scale-105 ${
                      work.ratio === 'portrait' ? 'aspect-[3/4]' : 'aspect-[4/3]'
                    }`}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50/95 via-transparent to-transparent opacity-80"></div>

                  <button
                    type="button"
                    onClick={() => toggleLike(work.id)}
                    aria-label={isLiked ? '取消收藏' : '收藏'}
                    className="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full bg-background-50/70 text-foreground-200 backdrop-blur-sm transition-colors hover:text-accent-500"
                  >
                    <i className={`${isLiked ? 'ri-heart-fill text-accent-500' : 'ri-heart-line'} text-lg`}></i>
                  </button>

                  <div className="absolute bottom-3 left-3 right-3 flex items-end justify-between">
                    <div>
                      <h3 className="font-heading text-base font-bold text-foreground-50">{work.title}</h3>
                      <p className="mt-0.5 text-xs text-foreground-300">
                        {work.style} · {work.artist} · {work.updated}
                      </p>
                    </div>
                    <span className="flex items-center gap-1 rounded-full bg-background-50/70 px-2.5 py-1 text-xs text-foreground-200 backdrop-blur-sm">
                      <i className="ri-fire-fill text-primary-400"></i>
                      {work.likes.toLocaleString()}
                    </span>
                  </div>
                </div>

                <div className="flex items-center justify-between px-3 py-2.5">
                  <div className="flex flex-wrap gap-1.5">
                    {work.tags.map((tag) => (
                      <span key={tag} className="rounded bg-background-200/70 px-2 py-0.5 text-xs text-foreground-300">
                        #{tag}
                      </span>
                    ))}
                  </div>
                  <button
                    type="button"
                    className="flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500/10 px-3 py-1.5 text-xs font-medium text-primary-300 transition-colors hover:bg-primary-500 hover:text-background-50"
                  >
                    <i className="ri-download-2-line text-sm"></i>下载
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}